import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de différence de hauteur entre deux personnes";
const DESCRIPTION =
  "Calculatrice de différence de hauteur entre deux personnes. Outil en ligne en francais pour obtenir un resultat rapide, clair et utile dans vos besoins du quotidien.";
const KEYWORDS =
  "height difference calculator, calculatrice en ligne, outil pratique, utilitaire quotidien, resultat rapide";
const OG_URL =
  "https://do-calculate.com/calculator/fr/height-difference-calculator/";
function HeightDifferenceCalculator() {
  const [heightPerson1, setHeightPerson1] = useState("0");
  const [heightPerson2, setHeightPerson2] = useState("0");
  const [heightDifference, setHeightDifference] = useState(null);
  const [error, setError] = useState("");
  const calculateHeightDifference = () => {
    try {
      if (heightPerson1 === "0" && heightPerson2 === "0") {
        setError("Veuillez entrer des hauteurs correctes pour calculer la différence");
        return;
      }
      const difference = Math.abs(heightPerson1 - heightPerson2);
      setHeightDifference(difference);
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice offre un moyen simple de connaître la différence de hauteur entre deux personnes. 
                  Qu'il s'agisse de comparer votre hauteur avec celle d'un ami ou d'un membre de votre famille, cet outil 
                  peut vous aider à obtenir la réponse rapidement et facilement. La différence de hauteur dépend de 
                  l'entrée des hauteurs des deux personnes que vous souhaitez comparer. Cet outil est utile dans de 
                  nombreux scénarios, comme comparer la hauteur des enfants avec les parents ou simplement par curiosité.
                </p>
                <p>
                  Par exemple, si vous souhaitez connaître la différence de hauteur entre une personne mesurant 180 cm 
                  et une autre mesurant 170 cm, vous pouvez utiliser cette calculatrice pour déterminer la différence avec précision. 
                  La différence est calculée simplement en soustrayant la plus petite hauteur de la plus grande. 
                  Ces informations peuvent être utiles lors du choix des vêtements ou lors de l'achat de chaussures à talon haut, 
                  car la différence de hauteur peut affecter vos choix.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="p-3">
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="1st-Input">Hauteur de la première personne :</label>
                    <input
                      id="1st-Input"
                      type="number"
                      value={heightPerson1}
                      onChange={(e) => setHeightPerson1(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                    <span className="input-group-text">cm</span>
                  </div>
                  <div className="form-group d-flex align-items-center">
                    <label htmlFor="2nd-Input">Hauteur de la deuxième personne :</label>
                    <input
                      id="2nd-Input"
                      type="number"
                      value={heightPerson2}
                      onChange={(e) => setHeightPerson2(e.target.value)}
                      className="form-control"
                      style={{ width: "75%" }}
                    />
                    <span className="input-group-text">cm</span>
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateHeightDifference}
                  >
                    Calculer
                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">Erreur : {error}</p>
                ) : (
                  heightDifference !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>Différence de hauteur : {heightDifference.toFixed(2)} cm</p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Comment calculer la différence de hauteur entre deux personnes
              </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 1 : Déterminer la hauteur de la première personne
                    </h2>
                  </u>
                  <p>
                    Au départ, vous devez connaître la hauteur de la première personne avec laquelle vous souhaitez 
                    calculer la différence de hauteur. La hauteur doit être mesurée en centimètres (cm) pour faciliter 
                    le calcul. Cette personne peut être vous-même ou toute autre personne dont vous souhaitez comparer 
                    la hauteur. Assurez-vous de mesurer la hauteur avec précision, car des valeurs correctes vous aideront 
                    à obtenir des résultats précis et fiables.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 2 : Déterminer la hauteur de la deuxième personne
                    </h2>
                  </u>
                  <p>
                    Après avoir déterminé la hauteur de la première personne, l'étape suivante consiste à connaître 
                    la hauteur de la deuxième personne. Encore une fois, assurez-vous que la hauteur est mesurée en centimètres (cm). 
                    La deuxième personne peut être un ami, un membre de la famille ou même une personnalité publique dont vous 
                    souhaitez connaître la différence de hauteur avec vous. Entrer la hauteur avec précision vous aidera à 
                    obtenir des calculs précis de la différence de hauteur.
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 3 : Calculer la différence de hauteur
                    </h2>
                  </u>
                  <p>
                    Après avoir entré les hauteurs des deux personnes, vous pouvez calculer la différence entre elles facilement. 
                    Pour calculer la différence de hauteur, il vous suffit de soustraire la plus petite hauteur de la plus grande. 
                    Cette opération mathématique simple vous donnera la différence exacte de hauteur entre les deux personnes. 
                    Si le résultat est zéro, cela signifie que les deux personnes sont de la même hauteur. Si le résultat est 
                    positif, vous saurez qui est le plus grand.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Exemple : Si la hauteur de la première personne est de 180 cm et celle de la deuxième est de 170 cm, 
                    la différence de hauteur est de 10 cm.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      Étape 4 : Utiliser la différence de hauteur
                    </h2>
                  </u>
                  <p>
                    Une fois que vous connaissez la différence de hauteur, vous pouvez l'utiliser à plusieurs fins, 
                    notamment pour le choix des vêtements, les achats, ou simplement pour satisfaire votre curiosité. 
                    Cette information peut être utile dans de nombreuses situations pratiques, comme choisir des vêtements 
                    assortis, acheter des chaussures ou évaluer les besoins en mobilier. La connaissance de la différence 
                    de hauteur peut également vous aider à mieux comprendre les proportions et les différences physiques 
                    entre les personnes.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    Exemple : Si vous savez que votre ami est 15 cm plus grand que vous, vous pouvez adapter vos achats 
                    et vos choix en conséquence, comme le choix de vêtements ou d'accessoires.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default HeightDifferenceCalculator;
